/**
 * Above the shortlist (Sofia, Oct 19 2026): pick people (or a whole page) and accept them in one
 * go, and page through the list 25 at a time instead of one long scroll.
 */
import { Button } from '@finn-auto/design-system/atoms/button';

export const SHORTLIST_PAGE = 25;

export function ShortlistBar({
  pageIds,
  selected,
  onSelect,
  onAccept,
  accepting,
  page,
  pages,
  onPage,
}: {
  pageIds: string[];
  selected: Set<string>;
  onSelect: (ids: string[], on: boolean) => void;
  onAccept: () => void;
  /** "3 of 25" while a bulk accept runs, else null. */
  accepting: string | null;
  page: number;
  pages: number;
  onPage: (p: number) => void;
}) {
  if (!pageIds.length) return null;
  const allOnPage = pageIds.every((id) => selected.has(id));
  return (
    <div className="flex flex-wrap items-center gap-3 text-[13px]">
      <label className="flex items-center gap-2">
        <input type="checkbox" checked={allOnPage} onChange={(e) => onSelect(pageIds, e.target.checked)} />
        Select all on this page
      </label>
      <Button variant="primary" size="sm" className="rounded-md" disabled={!selected.size || Boolean(accepting)} onClick={onAccept}>
        {accepting ? `Accepting ${accepting}…` : `Accept selected (${selected.size})`}
      </Button>
      {pages > 1 && (
        <span className="ml-auto flex items-center gap-2">
          <Button variant="outline" size="sm" className="rounded-md" disabled={page === 0} onClick={() => onPage(page - 1)}>
            ← Previous
          </Button>
          <span className="text-[#707070]">
            Page {page + 1} of {pages}
          </span>
          <Button variant="outline" size="sm" className="rounded-md" disabled={page >= pages - 1} onClick={() => onPage(page + 1)}>
            Next →
          </Button>
        </span>
      )}
    </div>
  );
}
